import React from 'react';
import { AlertTriangle, Replace, Copy, X } from 'lucide-react';
import { Button } from '../ui/button';
import { useLanguage } from '../../contexts/LanguageContext';

export const DuplicateDialog = ({
  duplicateMatch, handleDuplicateKeepNew, handleDuplicateKeepBoth,
  handleDuplicateKeepExisting, saving
}) => {
  const { t } = useLanguage();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="rounded-2xl p-6 mx-4 max-w-md w-full shadow-xl" style={{ backgroundColor: 'white' }} data-testid="duplicate-dialog">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'hsl(40, 90%, 92%)' }}>
            <AlertTriangle className="w-5 h-5" style={{ color: 'hsl(40, 90%, 40%)' }} />
          </div>
          <div>
            <h3 className="font-semibold text-lg" style={{ color: 'hsl(143, 28%, 25%)' }}>{t('duplicateFound')}</h3>
            <p className="text-sm" style={{ color: 'hsl(125, 12%, 32%)' }}>
              {t('youAlreadyHave').replace('{name}', duplicateMatch.common_name)}
            </p>
          </div>
        </div>

        <div className="space-y-2">
          <Button
            onClick={handleDuplicateKeepNew}
            disabled={saving}
            className="w-full justify-start gap-2"
            style={{ backgroundColor: 'hsl(143, 28%, 25%)', color: 'white' }}
            data-testid="duplicate-keep-new"
          >
            <Replace className="w-4 h-4" />
            {saving ? t('saving') : t('replaceExisting')}
          </Button>
          <Button
            onClick={handleDuplicateKeepBoth}
            disabled={saving}
            variant="outline"
            className="w-full justify-start gap-2"
            style={{ borderColor: 'hsl(143, 28%, 85%)', color: 'hsl(143, 28%, 25%)' }}
            data-testid="duplicate-keep-both"
          >
            <Copy className="w-4 h-4" />
            {saving ? t('saving') : t('keepBoth')}
          </Button>
          <Button
            onClick={handleDuplicateKeepExisting}
            variant="outline"
            className="w-full justify-start gap-2"
            style={{ borderColor: 'hsl(143, 28%, 85%)', color: 'hsl(125, 12%, 32%)' }}
            data-testid="duplicate-keep-existing"
          >
            <X className="w-4 h-4" />
            {t('discardThisOne')}
          </Button>
        </div>
      </div>
    </div>
  );
};
